export enum StateKey {
  AUTH_TOKEN = 'auth_token',
  COMMUNITY = 'community',
}

export class StateManager {
  public static setValue(key: StateKey, value: any) {
    if ( value ) {
      window.localStorage.setItem(key, value)
    }
  }
  public static getValue(key: StateKey) {
    return window.localStorage.getItem(key)
  }
  public static clearValue(key: StateKey) {
    window.localStorage.removeItem(key)
  }
}